import LocalizedLink from '@/components/layout/LocalizedLink'
import { ChevronLeft } from 'lucide-react'
import { cn } from '@/utils/cn'

export interface BreadcrumbItem {
  label: string
  to?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

export default function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav
      className={cn('flex items-center space-x-2 space-x-reverse text-sm text-gray-600 dark:text-gray-400', className)}
      aria-label="Breadcrumb"
    >
      <ol className="flex items-center space-x-2 space-x-reverse">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronLeft className="w-4 h-4 mx-2 text-gray-400 dark:text-gray-500" aria-hidden="true" />
              )}
              {isLast ? (
                <span className="text-gray-900 dark:text-gray-100 font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : item.to ? (
                <LocalizedLink
                  to={item.to}
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  {item.label}
                </LocalizedLink>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

